<template>
  <div class="page">
    <HeaderMain
      v-if="currentComponent === 'ViberActivation'"
      v-html="
        $t(`page.${componentState.pathToTranslate}.mainheader`, {
          value: numberState,
          msgr: 'Viber',
        })
      "
    />
    <HeaderMain v-else-if="!!componentState?.pathToTranslate" textCenter>{{
      $t(`page.${componentState.pathToTranslate}.mainheader`, {
        msgr: "Viber",
      })
    }}</HeaderMain>
    <component
      :is="componentState.component"
      :number="numberState"
      :messenger="messengerState"
      @nextStage="onNextAction"
    />
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch, watchEffect, onUnmounted } from "vue";
import HeaderMain from "@/components/Recurring/HeaderMain.vue";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";

import ViberActivation from "@/components/activation/ViberActivation.vue";
import TimeExpired from "@/components/activation/TimeExpiredActivation.vue";
import GenerationCode from "@/components/activation/GenerationCodeActivation.vue";
import ScanCode from "@/components/activation/ScanCodeActivation.vue";

import useCustomActivation from "@/components/activation/api/useCustomActivation";
import usePusherActivation from "@/components/activation/api/usePusherActivation";

const { pusherActivation, pusherStatus, pusherKill } = usePusherActivation();
const { getCustomStatus, customStatus } = useCustomActivation();

const router = useRouter();
const route = useRoute();
const store = useStore();

const components = {
  ViberActivation: {
    component: ViberActivation,
    pathToTranslate: "activation",
  },
  GenerationCode: {
    component: GenerationCode,
    pathToTranslate: "code_gen1",
  },
  TimeExpired: {
    component: TimeExpired,
  },
  ScanCode: {
    component: ScanCode,
  },
};

const currentComponent = ref("ViberActivation");

const componentState = computed(() => {
  return components[currentComponent.value];
});

const numberState = computed(() => store.state.activation.number);

const messengerState = computed(() => store.state.activation.messenger);

/**
 * Эта функция принимает параметр nextStage и выполняет различные действия на основе его значения.
 *
 * @param {string} nextStage - событие, которое передается от детей для определения последующих действий.
 * @return {void}
 */
const onNextAction = (nextStage) => {
  switch (nextStage || nextStage.value) {
    case "viberActivation":
      currentComponent.value = "ViberActivation";
      break;
    case "generationCode":
      if (store.state.activation.isPusher) pusherActivation(numberState.value);
      currentComponent.value = "GenerationCode";
      break;
    case "scanCode":
      currentComponent.value = "ScanCode";
      break;
    case "timeOver":
      currentComponent.value = "TimeExpired";
      break;
    case "integration":
      router.push({ name: "Integration" });
      break;
    case "activated":
    case "successActivation":
      store.commit("openDialog", {
        name: "SuccessActivationDialog",
        params: { number: numberState.value },
      });
      // the CRM is picked on the success page now, not before activation
      router.push({ name: "SuccessActivation", query: { messenger: "viber" } });
      break;
    case "errorActivation":
      router.push({ name: "SuccessActivation", query: { messenger: "viber" } });
      break;
    case "oops":
    default:
      router.push({ name: "Oops" });
      break;
  }
};

const statusState = computed(() => {
  return {
    pusherStatus: pusherStatus.value,
    customStatus: customStatus.value,
  };
});

watch(
  () => store.state.activation.qrLink, // ! store.state.activation.qrLink
  (newLink) => {
    if (
      newLink &&
      componentState.value.pathToTranslate !== "activation" //
    ) {
      onNextAction("scanCode");
    }
  }
);

watch(statusState, () => {
  const { pusherStatus, customStatus } = statusState.value;
  if (pusherStatus) {
    if (!store.state.activation.isPusher) {
      getCustomStatus(numberState, messengerState.value);
    } else {
      onNextAction(pusherStatus);
    }
  }
});

onMounted(() => {
  if (!store.state.activation.messenger) {
    store.commit("activation/SET_MESSENGER", "viber");
  }
  // если номер передается параметром, а в сторе его нет, то добавляем его в стор
  if (!store.state.activation.number && route?.params?.number) {
    store.commit("activation/SET_NUMBER", route?.params?.number);
  }
  //   ???
  if (!store.state.numberData) {
    router.push({ name: "Oops" });
  }
});

onUnmounted(() => {
  store.commit("activation/CLEAR_QR_LINK");

  store.commit("clearNumberData");
});
</script>

<style lang="scss" scoped>
.page {
  padding: 0 20px;

  :deep(.txt) {
    font-weight: 500;
    margin-bottom: 30px;
  }
}

@media screen and (max-width: 850px) {
  .dialog {
    width: 100%;
  }

  .page {
    .block {
      .start {
        .block-header {
          font-size: 20px;
          line-height: 150%;
        }
      }
    }
  }
}

@media screen and (max-width: 680px) {
  .page {
    .block {
      flex-direction: column;
      padding: 15px;
      gap: 20px;

      .img1 {
        margin: auto;
        width: 45%;
        height: 50%;
      }

      .start {
        padding: 0;

        .block-header {
          font-size: 14px;
        }

        ul {
          li {
            line-height: 150%;
            font-size: 12px;
          }
        }

        .btn {
          width: 100%;
        }
      }
    }
  }
}

@media screen and (max-width: 550px) {
}

@media screen and (max-width: 450px) {
  .page .block {
    gap: 0;
  }
}

@media screen and (max-width: 400px) {
  .page {
    .block {
      .start {
        padding: 0;

        .block-header {
          font-size: 12px;
        }
      }
    }
  }
}

// @media screen and (max-width: $tablet-max-size) {
//   .modal {
//     width: 100%;
//   }
// }
</style>
